import { atom } from 'nanostores';

export interface ReferralEditorRequest {
  requestId: number;
  patientId: string;
  draftId?: string;
}

export const $referralEditorRequest = atom<ReferralEditorRequest | null>(null);

let nextRequestId = 0;

export function openReferralEditor(patientId: string, draftId?: string): void {
  nextRequestId += 1;
  $referralEditorRequest.set({ patientId, draftId, requestId: nextRequestId });
}

export function closeReferralEditor(): void {
  $referralEditorRequest.set(null);
}
